import { NotFoundPage } from 'features/Misc'
import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'
import React, { useEffect } from 'react'

import { useLinkDetails } from './redirects.services'

const RedirectsV2Page = () => {
  const { query } = useRouter()

  const { data: linkDetails, isError } = useLinkDetails(query?.slug as string)

  useEffect(() => {
    if (linkDetails && query.slug) {
      // @ts-ignore
      window.location = linkDetails.address
    }
  }, [linkDetails, query.slug])

  if (isError) {
    return <NotFoundPage />
  }
  return (
    <h1 className="text-3xl flex-1 flex justify-center items-center">
      <CommunityRedirectSEO
        slug={(typeof query.slug === 'string' && query.slug) || ''}
      />
      Hey! <br />
      Take a back seat while we are redirecting you... 🚀
    </h1>
  )
}

export default RedirectsV2Page

type seoDetailsType = {
  seoTitle: string
  seoDescription: string
  seoCanonical: string
}

type perPageSeoType = {
  [key: string]: seoDetailsType
}

const perPageSeo: perPageSeoType = {
  whatsapp: {
    seoTitle: 'Join Whatsapp Group - Devsnest',
    seoDescription:
      'Join the WhatsApp Group to make sure you get all the notifications and updates about everything happening in your super active community, Devsnest.',
    seoCanonical: 'https://devsnest.in/whatsapp'
  },
  discord: {
    seoTitle: 'Join Discord Server - Devsnest',
    seoDescription:
      'Join the Discord Server to become a part of the super active community of 17K+ like-minded individuals connecting and upskilling with one another every day.',
    seoCanonical: 'https://devsnest.in/discord'
  }
}

export const CommunityRedirectSEO = ({ slug }: { slug: string }) => {
  return (
    <NextSeo
      title={perPageSeo[slug]?.seoTitle}
      description={perPageSeo[slug]?.seoDescription}
      canonical={perPageSeo[slug]?.seoCanonical}
      openGraph={{
        url: perPageSeo[slug]?.seoCanonical
      }}
    />
  )
}
